import { Action, createReducer, on } from '@ngrx/store';

import { SiteStatus } from 'src/app/model/site';
import * as SiteListActions from './site-list.actions';

export interface State {
    sites: SiteStatus[];
    loading: boolean;
    deletingSite: boolean;
}

const initialState: State = {
    sites: [],
    loading: false,
    deletingSite: false,
};

const siteListReducer = createReducer(
    initialState,
    on(SiteListActions.getSitesData, (state) => ({ ...state, loading: true })),
    on(SiteListActions.getSitesDataSuccess, (state, payload) => ({
        ...state,
        sites: payload.sites.map(s => new SiteStatus(s)),
        loading: false,
    })),
    on(SiteListActions.getSitesDataFailed, (state) => ({ ...state, loading: false })),
    on(SiteListActions.getSiteOwnerSuccess, (state, payload) => {
        const siteS = state.sites.find(ss => ss.SiteId === payload.siteId);
        if (!siteS) {
            return { ...state };
        }
        const indexS = state.sites.indexOf(siteS);
        const s = { ...siteS, Owner: payload.user };
        return { ...state, sites: [
            ...state.sites.slice(0, indexS),
            s,
            ...state.sites.slice(indexS + 1)
        ] };
    }),
    on(SiteListActions.deleteSite, (state) => ({
        ...state,
        deletingSite: true
    })),
    on(SiteListActions.deleteSiteSuccess, (state, payload) => ({
        ...state,
        sites: state.sites.filter(site => site.SiteId !== payload.siteId),
        deletingSite: false
    })),
    on(SiteListActions.deleteSiteFailed, (state) => ({
        ...state,
        deletingSite: false
    })),
);

export const reducer = (state: State | undefined, action: Action): State => siteListReducer(state, action);

